module.exports = __webpack_public_path__ + "static/media/thank-you.14ca2369.png";